import React from "react";
import site from "../content/site";
import about from "../content/about";

const AboutUs = ({ classicHeader, darkTheme }) => {
  const yearsOnAws = new Date().getFullYear() - site.awsStartYear;
  // Split the heading so "Will Laws," is highlighted in the primary colour,
  // matching the original visual treatment.
  const headingBefore = about.heading.split("Will Laws,")[0];
  const headingAfter = about.heading.split("Will Laws,")[1] || "";

  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {about.overline}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {about.title}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              {headingBefore}
              <span className="text-primary">Will Laws,</span>
              {headingAfter}
            </h2>
            {about.paragraphs.map((p, i) => (
              <p key={i} className={darkTheme ? "text-white-50" : ""}>
                {p}
              </p>
            ))}
          </div>
          {/* About me content end */}
          {/* about me personal details start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>
                  {site.name}
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a
                    href={`mailto:${site.email}`}
                    data-analytics-event="Email Will About"
                  >
                    {site.email}
                  </a>
                </li>
                <li>
                  <span className="fw-600 me-2">Blog:</span>
                  <a
                    href={site.blog.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-analytics-event="Visit 123cloud.st About"
                  >
                    {site.blog.text}
                  </a>
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>
                  {site.from}
                </li>
              </ul>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>{yearsOnAws}</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years on AWS
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>{about.certCount}</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  AWS Certifications
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>{about.communityCount}</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Community Members Built
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>{about.reInventAppearances}</span>x
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  re:Invent Speaker
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
